"use strict";
$(function ($) {

  /*ハンバーガーメニュー*/
  $('#js-humberger').on('click',function() {
    if($('#js-humberger').hasClass('is-openSP')) {
      $('#js-humberger,#js-drawer-menu').removeClass('is-openSP');
    } else {
      $('#js-humberger,#js-drawer-menu').addClass('is-openSP');
    }
  });

  /*ハンバーガーメニュー展開時、クリックで閉じる*/
  $('#js-drawer-menu a[href]').on('click',function() {
    $('#js-humberger').trigger('click');
  });

  /*ハンバーガーメニュー開いている時のスクロール禁止*/
  let state = false;
  let pos;
  $('#js-hamburger').on('click', function(){
    if (state == false) {
      pos = $(window).scrollTop();
      $('body').addClass('js-fixed').css({'top': -pos});
      state = true;
    } else {
      $('body').removeClass('js-fixed').css({'top': 0});
      window.scrollTo(0, pos);
      state = false;
    }
  });

  /*ナビメニュー選択中のページURLに色がつく*/

  $(document).ready(function() {
    // 現在のページのURLを取得
    let currentPage = window.location.pathname.split("/").pop();
    // ナビゲーションアイテムのリンクをチェックし、対応するアイテムに「current」クラスを追加
    $('.nav__item').each(function() {
        let link = $(this).find('.nav-item__link');
        let linkHref = link.attr('href');
        let linkPage = linkHref.split("/").pop();
        if (currentPage === "" && linkPage === "index.html") {
            $(this).addClass('current');
        } else if (currentPage === linkPage) {
            $(this).addClass('current');
        }
    });
  });

});
